import { SubmitHandler, UseFormReturn } from "react-hook-form";
import { ClientCompanyFormValues } from "../lib/clientCompanyForm";
import Form from "./form/Form";
import FormControl from "./form/FormControl";
import Input from "./form/Input";

type ClientCompanyFormProps = {
  id: string;
  form: UseFormReturn<ClientCompanyFormValues>;
  onSubmit: SubmitHandler<ClientCompanyFormValues>;
  submitError: string | null;
  withPlaceholders?: boolean;
};

function ClientCompanyForm({
  id,
  form,
  onSubmit,
  submitError,
  withPlaceholders = false,
}: ClientCompanyFormProps) {
  return (
    <Form id={id} className="authForm" form={form} onSubmit={onSubmit}>
      {submitError ? (
        <p className="errorMessage" role="alert">
          {submitError}
        </p>
      ) : null}

      <fieldset className="formFieldset">
        <legend className="formLegend">Company details</legend>
        <div className="formColumns">
          <FormControl<ClientCompanyFormValues> label="Name" name="name">
            <Input<ClientCompanyFormValues>
              name="name"
              rules={{ required: "Name is required" }}
              autoComplete="organization"
              placeholder={withPlaceholders ? "Acme Corp" : undefined}
            />
          </FormControl>

          <FormControl<ClientCompanyFormValues>
            label="Registration Number"
            name="registrationNumber"
          >
            <Input<ClientCompanyFormValues>
              name="registrationNumber"
              rules={{
                required: "Registration number is required",
              }}
              placeholder={withPlaceholders ? "123456-7890" : undefined}
            />
          </FormControl>
        </div>
      </fieldset>

      <fieldset className="formFieldset">
        <legend className="formLegend">Contact</legend>
        <div className="formColumns">
          <FormControl<ClientCompanyFormValues>
            label="Contact Email"
            name="contactEmail"
          >
            <Input<ClientCompanyFormValues>
              name="contactEmail"
              type="email"
              autoComplete="email"
              placeholder={withPlaceholders ? "contact@acme.com" : undefined}
            />
          </FormControl>

          <FormControl<ClientCompanyFormValues>
            label="Contact Phone"
            name="contactPhone"
          >
            <Input<ClientCompanyFormValues>
              name="contactPhone"
              autoComplete="tel"
              placeholder={withPlaceholders ? "+354 555 0000" : undefined}
            />
          </FormControl>
        </div>

        <FormControl<ClientCompanyFormValues> label="Address" name="address">
          <Input<ClientCompanyFormValues>
            name="address"
            autoComplete="street-address"
            placeholder={withPlaceholders ? "Street 1, City" : undefined}
          />
        </FormControl>
      </fieldset>
    </Form>
  );
}

export default ClientCompanyForm;
